var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import cardMap from '@app/games/shared/card-map';
import { cardValues } from '@app/_v2/games/blackjack/models/card-values.model';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
var MersenneTwister = require('mersennetwister');
var log = debug('edg:reply-blackjack');
var ReplyBlackjackComponent = /** @class */ (function (_super) {
    __extends(ReplyBlackjackComponent, _super);
    function ReplyBlackjackComponent(socket, balanceHistory) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.balanceHistory = balanceHistory;
        _this.data = null;
        _this.deck = [];
        return _this;
    }
    ReplyBlackjackComponent.prototype.initialize = function (data) {
        if (data.game !== 'blackjack') {
            this._error = true;
            return;
        }
        this.data = data.gameData;
        this.data.generated = false;
        this.data.game = 'blackjack';
        this.prepareDealerCards();
    };
    ReplyBlackjackComponent.prototype.generateGame = function () {
        var deck = this.reconstructDeck(this.serverSeed, this.playerSeed);
        this.data = {
            numDealedCards: 4,
            playerCards: [[deck[0], deck[2]]],
            dealerCards: [deck[1], deck[3]],
            shuffledDeck: deck,
            generated: true,
            splits: [],
            stands: [],
            game: 'blackjack',
        };
        this.prepareDealerCards();
    };
    ReplyBlackjackComponent.prototype.prepareDealerCards = function () {
        var deck = this.data.shuffledDeck;
        if (!deck) {
            return;
        }
        var startIndex = this.data.numDealedCards;
        if (deck.length > 0 && !this.data.generated) {
            var dealerAces = 0;
            var dVal = this.getDealerValue();
            if (dVal !== 21) {
                if (deck[1] % 13 === 0) {
                    dealerAces++;
                }
                if (deck[3] % 13 === 0) {
                    dealerAces++;
                }
                if (dVal > 21) {
                    while (dVal > 21 && dealerAces > 0) {
                        dVal -= 10;
                        dealerAces--;
                    }
                }
                if (dVal < 17) {
                    while (dVal < 17) {
                        var cardIndex = deck[startIndex] % 13;
                        var cardValue = cardValues[cardIndex];
                        if (cardIndex === 0) {
                            dealerAces++;
                        }
                        if (dVal + cardValue > 21 && dealerAces > 0) {
                            dVal = dVal + cardValue - 10;
                            dealerAces--;
                        }
                        else {
                            dVal += cardValue;
                        }
                        this.data.dealerCards.push(deck[startIndex]);
                        startIndex++;
                    }
                }
            }
        }
        this.prepareDeck(startIndex);
    };
    ReplyBlackjackComponent.prototype.prepareDeck = function (startIndex) {
        this.deck = [];
        var deck = this.data.shuffledDeck;
        if (deck.length > 0) {
            for (var i = startIndex; i < startIndex + 5; i++) {
                this.deck.push(deck[i]);
            }
        }
        this._loading = false;
    };
    ReplyBlackjackComponent.prototype.getCardName = function (card) {
        return cardMap[card % 52];
    };
    ReplyBlackjackComponent.prototype.getDealerValue = function () {
        var sum = 0;
        var aces = 0;
        if (this.data && this.data.dealerCards.length) {
            this.data.dealerCards.forEach(function (card) {
                var value = cardValues[card % 13];
                sum += value;
                if (value === 11) {
                    aces++;
                }
            });
            while (sum > 21 && aces) {
                aces--;
                sum -= 10;
            }
        }
        return sum;
    };
    ReplyBlackjackComponent.prototype.getDealerCardCount = function (handIndex) {
        if (!this.data || !this.data.dealerCards) {
            return 0;
        }
        return this.data.dealerCards.length;
    };
    ReplyBlackjackComponent.prototype.hasSplit = function (handIndex) {
        if (!this.data || !this.data.splits) {
            return false;
        }
        return this.data.splits.length >= handIndex;
    };
    ReplyBlackjackComponent.prototype.getCardValue = function (card) {
        return cardValues[card % 13];
    };
    ReplyBlackjackComponent.prototype.handClass = function (handIndex) {
        return {
            active: true,
            hidden: this.data.splits.length < handIndex,
        };
    };
    ReplyBlackjackComponent.prototype.reconstructDeck = function (srvSeed, clientSeed) {
        var deck = [];
        for (var i = 0; i < 208; i++) {
            // 4 decks
            deck.push(i);
        }
        return this.shuffleDeck(deck, srvSeed, clientSeed);
    };
    ReplyBlackjackComponent.prototype.getHandValue = function (handIndex) {
        var sum = 0;
        var aces = 0;
        if (this.data && this.data.playerCards.length && this.data.playerCards[handIndex] !== undefined) {
            this.data.playerCards[handIndex].forEach(function (card) {
                var value = cardValues[card % 13];
                sum += value;
                if (value === 11) {
                    aces++;
                }
            });
            while (sum > 21 && aces) {
                aces--;
                sum -= 10;
            }
        }
        return sum;
    };
    ReplyBlackjackComponent.prototype.getCardCount = function (handIndex) {
        if (this.data && this.data.playerCards.length && this.data.playerCards[handIndex] !== undefined) {
            return this.data.playerCards[handIndex].length;
        }
        return 0;
    };
    ReplyBlackjackComponent.prototype.shuffleDeck = function (deck, serverSeed, clientSeed) {
        serverSeed = serverSeed.replace('0x', '');
        clientSeed = clientSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted).map(function (item) { return parseInt(item, 16); });
        var mt = new MersenneTwister();
        mt.seedArray(seedsCombined);
        for (var i = 0; i < 800000; i++) {
            mt.real();
        }
        var shuffledDeck = deck.slice(0);
        for (var i = shuffledDeck.length - 1; i > 0; i -= 1) {
            var j = Math.floor(mt.real() * (i + 1));
            var temp = shuffledDeck[i];
            shuffledDeck[i] = shuffledDeck[j];
            shuffledDeck[j] = temp;
        }
        return shuffledDeck;
    };
    return ReplyBlackjackComponent;
}(ReplyAbstractComponent));
export { ReplyBlackjackComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-blackjack.component.ts.pre-build-optimizer.js